import { categories } from '@/mocks/categories';
import { useState } from 'react';

export default function CategoryGrid() {
  const [visibleCount, setVisibleCount] = useState(8);

  const visibleCategories = categories.slice(0, visibleCount);
  const hasMore = visibleCount < categories.length;

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Explore Popular Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Browse through our organized Vigorbuy Spreadsheet categories. Each section is carefully curated to help you find exactly what you are looking for.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {visibleCategories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:bg-background-200/80 transition-all duration-300"
            >
              <div className="relative w-full h-[160px] md:h-[180px] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} in Vigorbuy Spreadsheet category`}
                  title={`Vigorbuy Spreadsheet ${cat.name} Collection`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <h3 className="text-sm md:text-base font-semibold text-white whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <span className="text-xs text-white/70 flex items-center gap-1 mt-1">
                    Explore Collection
                    <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {hasMore && (
          <div className="text-center mt-8">
            <button
              onClick={() => setVisibleCount(categories.length)}
              className="px-6 py-2.5 rounded-full bg-background-100 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              View All {categories.length} Categories
              <i className="ri-arrow-down-line ml-1.5 w-4 h-4 inline-flex items-center justify-center align-middle"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}